import api from './api';

// Keep existing functions for backward compatibility
export const uploadImage = async (formData) => {
  try {
    const response = await api.post('/images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Upload error details:', error.response?.data);
    throw error;
  }
};

export const getImages = async (filters = {}) => {
  const response = await api.get('/images', { params: filters });
  return response.data;
};

export const getImage = async (id) => {
  const response = await api.get(`/images/${id}`);
  return response.data;
};
export const deleteImage = async (id) => {
  const response = await api.delete(`/images/${id}`, {
    params: {
      deleteFromOrthanc: true,
      _t: Date.now()
    }
  });
  return response.data;
};


export const findStudyId = async (id) => {
  const response = await api.get(`/images/${id}/find-study`);
  return response.data;
};

export const syncWithOrthanc = async () => {
  const response = await api.post('/images/sync-orthanc');
  return response.data;
};

export const fixMissingOrthancIds = async () => {
  const response = await api.post('/images/fix-orthanc-ids');
  return response.data;
};

export const extractMetadata = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  
  const response = await api.post('/images/extract-metadata', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};


export const getImagesEnhanced = async (params = {}) => {
  try {
    const response = await api.get('/images', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching images:', error);
    throw error;
  }
};

/**
 * Find Orthanc study for an image (enhanced version)
 */
export const findStudyForImage = async (imageId) => {
  try {
    const response = await api.get(`/images/${imageId}/find-study`);
    return response.data;
  } catch (error) {
    console.error('Error finding study:', error);
    throw error;
  }
};

/**
 * Get DICOM hierarchy for a patient
 */
export const getPatientStudies = async (patientId) => {
  try {
    const response = await api.get(`/images`, { params: { patientId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching patient studies:', error);
    throw error;
  }
};

/**
 * Upload multiple files (for ZIP and batch uploads)
 */
export const uploadMultipleFiles = async (files, patientData) => {
  try {
    const uploads = [];
    
    for (const file of files) {
      const formData = new FormData();
      formData.append('image', file);
      
      // Add patient data to each upload
      Object.keys(patientData).forEach(key => {
        if (patientData[key]) {
          formData.append(key, patientData[key]);
        }
      });
      
      const response = await api.post('/images/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      uploads.push(response.data);
    }
    
    return uploads;
  } catch (error) {
    console.error('Multiple upload error:', error);
    throw error;
  }
};

/**
 * Batch upload with progress tracking
 */
export const uploadBatch = async (files, patientData, onProgress) => {
  try {
    const results = [];
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('image', file);
      
      // Add patient data
      Object.keys(patientData).forEach(key => {
        if (patientData[key]) {
          formData.append(key, patientData[key]);
        }
      });
      
      const response = await api.post('/images/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      results.push(response.data);
      
      // Report progress
      if (onProgress) {
        onProgress(((i + 1) / files.length) * 100, i + 1, files.length);
      }
    }
    
    return results;
  } catch (error) {
    console.error('Batch upload error:', error);
    throw error;
  }
};